import setDeviceInfo from './set-device-info'
import setWindowDimensions from './set-window-dimensions'
import setCmpConsentData from './set-cmp-consent-data'

export default function(ctx) {
  setCmpConsentData(ctx)
  setWindowDimensions(ctx)
  setDeviceInfo(ctx)
}
